import React from 'react';
import { mediaUrl } from '../utils/media';

interface TeamMember {
  name: string;
  designation: string;
  image: string;
}

const TeamSection: React.FC = () => {
  const defaultProfileUrl = 'https://thehumanitytrust.in';
  const placeholderImage = (name: string) =>
    `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=FFF0E6&color=001D23&bold=true&size=400`;

  const teamMembers: TeamMember[] = [
    { name: 'Ananad Mashatte', designation: 'Founder', image: 'team-ananad-mashatte.jpg' },
    { name: 'Mahesh Biradar', designation: 'Co Founder', image: 'team-mahesh-biradar.jpg' },
    { name: 'Prashant Swamy', designation: 'Co Founder', image: 'team-prashant-swamy.jpg' },
  ];

  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center mx-auto mb-5" data-aos="fade-up" data-aos-delay="100" style={{ maxWidth: '500px' }}>
          <div className="d-inline-block rounded-pill bg-secondary text-primary py-1 px-3 mb-3">
            Team Members
          </div>
          <h1 className="display-6 mb-5">Let's Meet With Our Ordinary Soldiers</h1>
        </div>
        <div className="row g-4">
          {teamMembers.map((member, index) => (
            <div key={index} className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay={`${100 + index * 200}`}>
              <div className="team-item position-relative rounded overflow-hidden">
                <div className="overflow-hidden">
                  <img
                    className="img-fluid team-member-image"
                    src={mediaUrl(member.image)}
                    alt={member.name}
                    onError={(e) => {
                      const img = e.currentTarget;
                      img.onerror = null;
                      img.src = placeholderImage(member.name);
                    }}
                  />
                </div>
                <div className="team-text bg-light text-center p-4">
                  <h5>{member.name}</h5>
                  <p className="text-primary">{member.designation}</p>
                  <div className="team-social text-center">
                    <a className="btn btn-square" href={defaultProfileUrl} target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a className="btn btn-square" href={defaultProfileUrl} target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-twitter"></i>
                    </a>
                    <a className="btn btn-square" href={defaultProfileUrl} target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-instagram"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeamSection;

